import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MaintenanceProfileLayout from './MaintenanceProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import MaintenanceService from '../../services/MaintenanceService';
import PersonnelService from '../../services/PersonnelService';

const ViewMaintenance = ({ onClick }) => {
	const { id } = useParams();
	const [maintenance, setMaintenance] = useState(null); // Changed this from "eleve" to "Maintenance"
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [selectedPersonnel, setSelectedPersonnel] = useState('');
	const [selectedUrgence, setSelectedUrgence] = useState('');
	const [selectedStatut, setSelectedStatut] = useState('');
	const [personnelOptions, setPersonnelOptions] = useState([]);

	useEffect(() => {
		Promise.all([MaintenanceService.getMaintenance(id)]).then(
			([maintenanceData]) => {
				// Added "eleveData" to unpack second promise result
				setMaintenance(maintenanceData.data);

				if (maintenanceData && maintenanceData.data) {
					const personnelMaintenance = maintenanceData.data.personnel;
					setSelectedPersonnel(personnelMaintenance);

					const urgenceMaintenance = maintenanceData.data.urgence;
					setSelectedUrgence(urgenceMaintenance);

					const statutMaintenance = maintenanceData.data.statut;
					setSelectedStatut(statutMaintenance);
				}
			}
		);
	}, [id]);

	useEffect(() => {
		const fetchPersonnelOptions = async () => {
			try {
				const Personnels = await PersonnelService.getPersonnelOptions();
				setPersonnelOptions(Personnels);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchPersonnelOptions();
	}, []);

	const PERSONNEL_CHOICES = personnelOptions;

	const STATUT_CHOICES = [
		{ value: 'en_attente', label: 'En Attente' },
		{
			value: 'en_cours',
			label: 'En Cours'
		},
		{ value: 'terminee', label: 'Terminee' }
	];
	const URGENCE_CHOICES = [
		{ value: 'faible', label: 'Faible' },
		{ value: 'moderee', label: 'Moderee' },
		{
			value: 'elevee',
			label: 'Elevee'
		}
	];

	useEffect(() => {
		const fetchPersonnelOptions = async () => {
			try {
				const Personnels = await PersonnelService.getPersonnelOptions();
				setPersonnelOptions(Personnels);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchPersonnelOptions();
	}, []);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const maintenanceData = new FormData();

				// Add all your form data to the FormData
				maintenanceData.append('type_service', form.type_service.value);
				maintenanceData.append(
					'description_probleme',
					form.description_probleme.value
				);
				maintenanceData.append('fournisseur', form.fournisseur.value);
				maintenanceData.append('date_demande', form.date_demande.value);
				maintenanceData.append('contact', form.contact.value);
				maintenanceData.append('statut', form.statut.value);
				maintenanceData.append('type', form.type.value);
				maintenanceData.append('personnel', form.personnel.value);

				// Call the EleveService to create the eleve
				const response = await MaintenanceService.updateMaintenance(
					id,
					maintenanceData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations sur la demande de maintenance',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<MaintenanceProfileLayout>
			{maintenance && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									<Col xs={12} className="mb-3">
										{/* type_service   */}
										<Form.Group>
											<Form.Label htmlFor="type_service">
												Type de service <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="type_service"
												type="text"
												placeholder="Saisir le type de service de Maintenance"
												id="type_service"
												required
												isInvalid={!!feedbackMessages['type_service']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														type_service: e.target.value
															? ''
															: 'Le type de service est requis.'
													}));
												}}
												defaultValue={maintenance.type_service}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['type_service']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>
									<Col xs={12} className="mb-3">
										{/* description_probleme  */}
										<Form.Group>
											<Form.Label htmlFor="description_probleme">
												Description du probleme{' '}
												<span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="description_probleme"
												as="textarea"
												placeholder="Saisir la Description du probleme "
												id="description_probleme"
												required
												isInvalid={!!feedbackMessages['description_probleme']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														description_probleme: e.target.value
															? ''
															: 'La Description du probleme est requis.'
													}));
												}}
												defaultValue={maintenance.description_probleme}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['description_probleme']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* personnel */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="personnel">
												Personnel <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="personnel"
												required
												value={selectedPersonnel}
												isInvalid={!!feedbackMessages['personnel']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedPersonnel(value);
													// Reset feedback messages for points fields when personnel changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le personnel</option>
												{PERSONNEL_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback personnel="invalid">
												{feedbackMessages['personnel']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* date_demande */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="date_demande">
												Date de demande <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="date_demande"
												type="data"
												placeholder="Saisir la Date de demande de Maintenance"
												id="date_demande"
												required
												isInvalid={!!feedbackMessages['date_demande']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														date_demande: e.target.value
															? ''
															: 'La Date de demande est requise.'
													}));
												}}
												defaultValue={maintenance.date_demande}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_demande']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* Contact et statut  */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="contact">
														Contact <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="contact"
														type="number"
														placeholder="Saisir le Contact "
														id="contact"
														required
														isInvalid={!!feedbackMessages['contact']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																contact: e.target.value
																	? ''
																	: "Le Numero d'appel est requis."
															}));
														}}
														defaultValue={maintenance.contact}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['contact']}
													</Form.Control.Feedback>
												</Col>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="statut">
														Statut <span className="text-danger">*</span>
													</Form.Label>
													<Form.Select
														name="statut"
														required
														value={selectedStatut}
														isInvalid={!!feedbackMessages['statut']}
														onChange={(e) => {
															const value = e.target.value;
															setSelectedStatut(value);
															// Reset feedback messages for points fields when statut changes
															setFeedbackMessages({});
														}}
													>
														<option value="">Sélectionner le statut</option>
														{STATUT_CHOICES.map((choice, index) => (
															<option key={index} value={choice.value}>
																{choice.label}
															</option>
														))}
													</Form.Select>
													<Form.Control.Feedback statut="invalid">
														{feedbackMessages['statut']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* urgence */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="urgence">
												Urgence <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="urgence"
												required
												value={selectedUrgence}
												isInvalid={!!feedbackMessages['urgence']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedUrgence(value);
													// Reset feedback messages for points fields when urgence changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le urgence</option>
												{URGENCE_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback urgence="invalid">
												{feedbackMessages['urgence']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</MaintenanceProfileLayout>
	);
};

export default ViewMaintenance;
